<template>
    <BaseSheet
        v-if="loggedIn && isUserCardSheetOpen"
        :is-visible="isUserCardSheetOpen"
        class="user-card-sheet"
        @close="modalStore.close('userCardSheet')"
    >
        <template #title>
            Mijn We Are Public-pas
        </template>

        <template #subTitle>
            <p>Met deze pas heb je toegang tot alle programma’s op ons platform. Neem wel je ID mee.</p>

            <h4>{{ user.first_name }} {{ user.last_name }}</h4>
        </template>

        <template #default>
            <UserBarcode />
        </template>

        <template #footer>
            <img src="~/assets/img/logos/logo-black.svg">
        </template>
    </BaseSheet>
</template>

<script setup>
const modalStore = useModalStore();

const { user, loggedIn } = storeToRefs(useUserStore());

const isUserCardSheetOpen = computed(() => {
    return modalStore.activeModals.userCardSheet === true;
});
</script>

<style lang="less" src="./UserCardSheet.less" />
